var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicronesia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 40.0001C31.046 40.0001 40.0003 31.0458 40.0003 20.0001C40.0003 8.9544 31.046 9.15527e-05 20.0003 9.15527e-05C8.95461 9.15527e-05 0.000305176 8.9544 0.000305176 20.0001C0.000305176 31.0458 8.95461 40.0001 20.0003 40.0001Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 8.69562L20.8634 11.3528H23.6575L21.3972 12.9951L22.2605 15.6522L20.0002 14.01L17.7398 15.6522L18.6033 12.9951L16.3429 11.3528H19.1369L20.0002 8.69562Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.69586 20.0002L11.353 19.1367V16.3427L12.9953 18.6031L15.6524 17.7398L14.0102 20.0002L15.6524 22.2603L12.9953 21.3969L11.353 23.6573V20.8634L8.69586 20.0002Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 31.3044L19.137 28.6472H16.3429L18.6034 27.0049L17.74 24.3478L20.0003 25.99L22.2605 24.3478L21.3971 27.0049L23.6575 28.6472H20.8636L20.0003 31.3044Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3045 19.9999L28.6473 20.8633V23.6573L27.0051 21.3969L24.348 22.2602L25.9901 19.9999L24.348 17.7397L27.0051 18.6031L28.6473 16.3427V19.1366L31.3045 19.9999Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicronesia);
export default __webpack_public_path__ + "static/media/micronesia.c8b57660b0dca4e2f502d7c7da3b2d41.svg";
export { ForwardRef as ReactComponent };